import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../Components/Firebase";
import "../Styles/Sapakim/SQuotations.css";
import Loading from "../Components/Loading";
import AdminHead from "./AdminHead";

function Quotations() {
  const [quotations, setQuotations] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { UID } = useParams();
  useEffect(() => {
  const fetchData = async () => {
    try {
      // Fetch all quotations
      const quotationsSnapshot = await getDocs(collection(db, "Quotations"));
      const quotationData = quotationsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Fetch all Sapakim (suppliers)
      const sapakimSnapshot = await getDocs(collection(db, "Users"));
      const sapakimList = sapakimSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Map sapak name into each quotation
      const quotationsWithSapakName = quotationData.map((quotation) => {
        let sapakName = "—";
        if (quotation.SapakId) {
          const sapak = sapakimList.find((s) => s.id === quotation.SapakId);
          if (sapak) {
            sapakName = sapak.Name || "—";
          }
        }
        return {
          ...quotation,
          sapakName,
        };
      });

      // ✅ Sort by orderNumber ascending
      quotationsWithSapakName.sort((a, b) => {
        const numA = parseInt(a.orderNumber) || 0;
        const numB = parseInt(b.orderNumber) || 0;
        return numB - numA;
      });

      setQuotations(quotationsWithSapakName);
    } catch (error) {
      console.error("שגיאה בשליפת הצעות המחיר:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);


  const handleStatusUpdate = async (quotationId, newStatus) => {
    try {
      const quotationRef = doc(db, "Quotations", quotationId);
      await updateDoc(quotationRef, {
        QStatus: newStatus,
      });

      setQuotations((prev) =>
        prev.map((q) =>
          q.id === quotationId ? { ...q, QStatus: newStatus } : q
        )
      );
    } catch (error) {
      console.error(`שגיאה בעדכון הסטטוס ל-${newStatus}:`, error);
    }
  };

  const getStatusColor = (status) => {
    switch ((status || "").toLowerCase()) {
      case "pending":
        return "orange";
      case "rejected":
        return "red";
      case "approved":
        return "green";
      default:
        return "gray";
    }
  };

  const filteredQuotations = quotations.filter((q) => {
    const matchesSearch =
      (q.orderNumber && q.orderNumber.toString().includes(searchTerm)) ||
      (q.sapakName && q.sapakName.toLowerCase().includes(searchTerm.toLowerCase()));

    const matchesStatus =
      statusFilter === "all" ||
      (q.QStatus && q.QStatus.toLowerCase() === statusFilter.toLowerCase());

    return matchesSearch && matchesStatus;
  });

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <AdminHead />
      <div className="quotations-container">
        <h2>הצעות מחיר</h2>

        <div className="top-bar" style={{ alignItems: "center" }}>
          <input
            type="text"
            className="search-input"
            placeholder="חיפוש לפי מספר הזמנה או שם ספק..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ maxWidth: "300px" }}
          />

          <select
            className="search-input"
            style={{ maxWidth: "180px" }}
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            aria-label="סינון לפי סטטוס"
          >
            <option value="all">כל הסטטוסים</option>
            <option value="pending">בהמתנה</option>
            <option value="approved">מאושר</option>
            <option value="rejected">נדחה</option>
          </select>

          {/* Removed New Quotation Request Button */}
        </div>

        {filteredQuotations.length === 0 ? (
          <p>אין הצעות מחיר להצגה</p>
        ) : (
          <table className="quotations-table">
            <thead>
              <tr>
                <th>מספר</th>
                <th>סטטוס</th>
                <th>מספר הזמנה</th>
                <th>תאריך יצירה</th>
                <th>שם סוכן</th>
                <th>פעולה</th>
              </tr>
            </thead>
            <tbody>
              {filteredQuotations.map((q, index) => {
                const isPending = (q.QStatus || "").toLowerCase() === "pending";
                return (
                  <tr key={q.id}>
                    <td data-label="מספר">{index + 1}</td>
                    <td data-label="סטטוס">
                      <div
                        title={q.QStatus || "לא ידוע"}
                        style={{
                          width: "14px",
                          height: "14px",
                          borderRadius: "50%",
                          backgroundColor: getStatusColor(q.QStatus),
                          margin: "0 auto",
                        }}
                      />
                    </td>
                    <td data-label="מספר הזמנה">{q.orderNumber || "—"}</td>
                    <td data-label="תאריך יצירה">
                      {q.createdAt && typeof q.createdAt.toDate === "function"
                        ? q.createdAt.toDate().toLocaleString()
                        : "תאריך לא זמין"}
                    </td>
                    <td data-label="שם ספק">{q.sapakName}</td>
                    <td
                      data-label="פעולה"
                      style={{ display: "flex", gap: "8px", justifyContent: "center" }}
                    >
                      <button
                        onClick={() =>
                          navigate(`/AdminHome/${UID}/ViewQuotation/${q.id}`)
                        }
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          border: "none",
                          cursor: "pointer",
                          backgroundColor: "#007bff",
                          color: "#fff",
                          fontWeight: "600",
                        }}
                      >
                        הצג
                      </button>
                      <button
                        onClick={() => handleStatusUpdate(q.id, "approved")}
                        disabled={!isPending}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          border: "none",
                          cursor: isPending ? "pointer" : "not-allowed",
                          backgroundColor: isPending ? "green" : "#a0a0a0",
                          color: "#fff",
                          fontWeight: "600",
                        }}
                        title="אישור"
                      >
                        אישור
                      </button>
                      <button
                        onClick={() => handleStatusUpdate(q.id, "rejected")}
                        disabled={!isPending}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          border: "none",
                          cursor: isPending ? "pointer" : "not-allowed",
                          backgroundColor: isPending ? "red" : "#a0a0a0",
                          color: "#fff",
                          fontWeight: "600",
                        }}
                        title="דחייה"
                      >
                        דחייה
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

export default Quotations;
